'use strict';

var red$1 = require('../../../../_virtual/red.js_commonjs-exports.js');

Object.defineProperty(red$1.__exports, "__esModule", {
  value: true
});
red$1.__exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
red$1.__exports.default = _default;
